import React, { memo, useCallback, useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { ChevronRight, MegaNavFrame, QuoteIcon } from '@/app/assets/Icons';
import { Images } from '@/app/assets/images';
import { map } from '@/utils';
import { cn } from '@nextui-org/react';

import { IButton, ITypo } from '../../common';

interface IProps {
	item: any;
}

const MegaNav: React.FC<IProps> = ({ item }) => {
	const router = useRouter();

	const [activeTab, setActiveTab] = useState(item.children[0]);

	const handleChangeTab = useCallback(
		(item: any) => {
			if (activeTab.key === item.key) {
				router.push(item.href);
				return;
			}
			setActiveTab(item);
		},
		[activeTab]
	);

	return (
		<div className="row-center shadow-3 absolute inset-x-0 top-[72px] z-10 mx-9 hidden min-h-[100px] w-[calc(100%_-_72px)] gap-6 rounded-2xl bg-white p-4 lg:hidden lg:group-hover:flex xl:gap-[50px]">
			<div className="relative flex-1">
				{map(item.children, (item: any, idx) => {
					const isActive = activeTab.key === item.key;
					return (
						<IButton
							key={idx}
							className={cn(
								'hover:bg-mauvelous hover:text-bittersweet hover:border-mauvelous group/navCourse h-fit min-h-10 w-full justify-between rounded-lg p-3 hover:border hover:border-solid lg:min-h-12 lg:rounded-xl lg:p-3'
							)}
							variant={isActive ? 'light' : 'transparent'}
							onClick={() => handleChangeTab(item)}
						>
							<ITypo
								size={14}
								className="group-hover/navCourse:font-semibold"
								weight={isActive ? 'semi' : 'normal'}
							>
								{item.label}
							</ITypo>
							{item.title && (
								<ChevronRight
									className={cn(
										'text-gray group-hover/navCourse:text-bittersweet'
									)}
								/>
							)}
						</IButton>
					);
				})}
			</div>
			<div className="center relative min-w-[498px] max-w-[498px] flex-1">
				<div className="absolute lg:top-14 xl:top-10">
					<QuoteIcon className="text-bittersweet mx-auto" />
					<ITypo
						size={24}
						as="p"
						weight="semi"
						className="text-bittersweet mx-10 mb-2 mt-6 text-center"
					>
						{activeTab.title || item.title}
					</ITypo>
					{map(
						activeTab.descriptions || item.descriptions,
						(item: string, idx) => (
							<ITypo
								size={16}
								key={idx}
								as="p"
								className="text-black-1 mx-10 text-center"
							>
								{item}
							</ITypo>
						)
					)}
				</div>
				<MegaNavFrame className="text-mauvelous w-full" />
			</div>
			<div className="border-silver relative min-h-[332px] w-full flex-1 overflow-hidden rounded-xl border">
				<Image
					src={Images.common.detailNavImage}
					fill
					alt="DLA Da Nang"
					className="object-cover object-center"
					priority
					quality={100}
				/>
			</div>
		</div>
	);
};

export default memo(MegaNav);
